import { getUseResource } from '../resource';
import { zendeskResources } from '../builders/zendeskResources';
import { IResponse } from '../models/IResponse';
import { paginatedResourceQuery } from '../paginatedResourceQuery';
import { IServerSidePaginatedFetcherParams } from '../../contexts/Fetcher';

export interface IZendeskTicket {
  id: number;
  subject: string;
  description: string;
  status: string;
  priority: string;
  requester_id: number;
  organization_id: number;
  created_at: string;
  updated_at: string;
}

export interface IZendeskTicketsPage {
  tickets: IZendeskTicket[];
  total_items: number;
  page: number;
  page_size: number;
}

export const apiZendesk = {
  useReassignUser: getUseResource(zendeskResources.reassignUser, (body): void => body),
  useReassignOrganization: getUseResource(zendeskResources.reassignOrganization, (body): void => body),
  useGetUserTickets: getUseResource(
    zendeskResources.getUserTickets,
    (body): IResponse<IZendeskTicketsPage> => body,
    (params, pagination: IServerSidePaginatedFetcherParams) => paginatedResourceQuery(params, pagination)
  ),
};
